import PropTypes from 'prop-types';
import React from 'react';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement, RawHtml } from 'contest/components/brief/read-element';
import Textarea from '@99designs/react-components/components/Textarea';

export const ViewTextAreaElement = connectReadElement(RawHtml, element => ({
    html: element.metadata.formattedText,
}));

export class EditTextAreaElement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            value: event.target.value,
        });

        this.props.onChange(event.target.value);
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({
                value: this.props.defaultValue,
            });
        }
    }

    render() {
        return (
            <Textarea
                className="input-textarea input-width--max"
                value={this.state.value}
                onChange={this.handleChange}
                onBlur={this.props.onSave}
                isExpandable={true}
                isCollapsible={true}
                maxHeight={300}
            />
        );
    }
}

EditTextAreaElement.propTypes = {
    defaultValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export const ConnectedEditTextAreaElement = connectEditElementToBriefStore(
    EditTextAreaElement,
    element => ({
        defaultValue: element.value,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/textarea-element.jsx